module.exports = __webpack_public_path__ + "static/img/hero-bg.8b848b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/hero-bg.png
// module id = 5CI9
// module chunks = 1